var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"mouseenter":_vm.enter,"mouseleave":_vm.leave}},[_c('dot-line',{ref:"top",attrs:{"pos":"top"}}),_vm._t("default"),_c('dot-line',{ref:"bottom",attrs:{"pos":"bottom"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }